import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../config.js';
import { Login } from '../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../hook/UseLang.js';
import '../App.css'
import './facility.css'
//
import Mask from './components/MaskAnimation.js';
import Carousell from '../components/caro.js';
import Footer from './components/Footer.js';
import InViewComponent from './components/InView.js';
//
import LeftSvg from '../svgs/facility/leftSvg.js'
import RightSvg from '../svgs/facility/rightSvg.js'
//
import CONTENT from '../contents/facilities.js'

const NEARBY = {
    'gym':{
        title:{
            en:'Gym',
            tc:'健身房',
            sc:'健身房'
        }
    },
    'spa':{
        title:{
            en:'Spa / Massage'
            ,tc:'水療 / 按摩',
            sc:'水疗 / 按摩'
        },
    },
    'conveniance':{
        title:{
            en:'Conveniance stores',
            tc:'便利店',
            sc:'便利店'
        },
    },
    'flower':{
        title:{
            en:'Flower store',
            tc:'花店',
            sc:'花店'
        },
    },
    'Pet store':{
        title:{
            en:'Pet store',
            tc:'寵物店',
            sc:'宠物店'
        },
    },
    'Supermarket':{
        title:{
            en:'Supermarket',
            tc:'超市',
            sc:'超市'
        },
    },
    'wet market':{
        title:{
            en:'wet market',
            tc:'濕貨市場',
            sc:'湿货市场'
        },
    },
    'stainoary store':{
        title:{
            en:'stainoary store',
            tc:'文具店',
            sc:'文具店'
        },
    },
    'Phramcy':{
        title:{
            en:'Phramcy',
            tc:'藥房',
            sc:'药房'
        },
    },
    'Bakery':{
        title:{
            en:'Bakery',
            tc:'麵包店',
            sc:'面包店'
        },
    },
    'Clothing store':{
        title:{
            en:'Clothing store',
            tc:'服裝店',
            sc:'服装店'
        },
    },
    'Car Park':{
        title:{
            en:'Car Park',
            tc:'停車場',
            sc:'停车场'
        },
    },
    'Fruit stores':{
        title:{
            en:'Fruit stores',
            tc:'水果店',
            sc:'水果店'
        },
    },
    'Laundary store/ DIY Laundary store ':{
        title:{
            en:'Laundary store/ DIY Laundary store',
            tc:'洗衣店/自助洗衣店',
            sc:'洗衣店/自助洗衣店'
        },
    },
    'Liquior store ':{
        title:{
            en:'Liquior store',
            tc:'酒類店',
            sc:'酒类店'
        },
    },
    'Hair Salon ':{
        title:{
            en:'Hair Salon',
            tc:'髮型屋',
            sc:'发型屋'
        },
    },
    'Currency excange store ':{
        title:{
            en:'Currency excange store',
            tc:'貨幣兌換店',
            sc:'货币兑换店'
        },
    },
    // 'Gas station':{
    //     title:{
    //         en:'Gas station',
    //         tc:'加油站',
    //         sc:'加油站'
    //     },
    // }
}

const CARO1 = ['./images/facility/1caro_0.jpg','./images/facility/1caro_1.jpg','./images/facility/1caro_2.jpg',]
const CARO2 = ['./images/facility/2caro_0.jpg','./images/facility/2caro_1.jpg','./images/facility/2caro_2.jpg',]
function Component({}) {
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    const [lang, setLang] = useLang();
    //
    const [CaroIdx1, setCaroIdx1] = useState(0);
    const [CaroIdx2, setCaroIdx2] = useState(0);
    const ref1 = useRef()
    const ref2 = useRef()
    const ref2_5 = useRef()
    const ref3 = useRef()
    const ref4 = useRef()
    const ref4_2 = useRef()
    const ref5 = useRef()
    const ref5_2 = useRef()
    const ref6 = useRef()
    const ref7 = useRef()
    const ref8 = useRef()
    const refBullet = useRef()
    
    const cut1 = useRef()
    const cut2 = useRef()
    const cut3 = useRef()
    return(
        <div className='bg-white w-full flex flex-col'>
            <div className='w-full flex flex-col'>
                {/* sec1 */}
                <div className='w-full h-[50vh] addnavpadding relative'>
                    <div className='absolute bottom-5 left-5 vert-text text-white text-[8px] font-[500] m-show-d-hidden'>No. 21 Whitfield Road Causeway Bay Hong Kong Island Hong Kong</div>
                    <img src='./images/facility/banner.jpg' className='w-full h-full' style={{objectFit:'cover'}}></img>
                </div>
                <div className='relative x-padding w-full min-h-[97vh] flex flex-col items-center justify-center'>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                    <InViewComponent reffing={ref1} active='title_text_active'delay={2000}/>
                    <div ref={ref1} className='title_text relative text-d-35 playfair-display my-[79px]'>{CONTENT.ocean[lang]}</div>
                    <div ref={cut1} className='cut_down w-[1px] h-[70px] absolute top-0 left-50 bg-black'></div>
                    <InViewComponent reffing={cut1} active='cut_down_active'delay={2000}/>
                    <div className='w-full max-w-[1102px] relative flex flex-col items-end justify-center two-k-concept-max-w'>
                        <img className='w-full' src='./images/facility/sec1.png' style={{aspectRatio:(1102/579)}}></img>
                        {/* <img className='absolute left-0 bottom-0' src='./images/facility/1_right.jpg' style={{aspectRatio:(622/430)}}></img> */}
                        <div ref={ref2} className='title_text facility-sec1-text text-d-12 mt-[-6%] d-881' style={{}}>{CONTENT.text_1[lang]}</div>
                        <InViewComponent reffing={ref2} active='title_text_active'delay={0}/>
                    </div>
                    <div className='w-full relative my-[24px]'>
                        <div ref={ref2_5} className='d-1012-m-show max-w-[419px] text-d-12 title_text' style={{lineHeight:'30px'}}>{CONTENT.ocean[lang]}</div>
                        <InViewComponent reffing={ref2_5} active='title_text_active'delay={0}/>
                    </div>
                </div>
                {/* sec3 */}
                <div id='nearby facilities' className='w-full min-h-[97vh] flex flex-col items-center w-full relative py-[15vh]'>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full top-0 left-0' style={{objectFit:'cover'}}></img>
                    <div className='absolute w-full h-full bg-[#fff] opacity-[0.3] top-0 left-0'></div>
                    <div ref={cut3} className='cut_down flex flex-col items-center justify-center absolute top-0 left-[50%]'>
                        <div className='w-[1px] h-[10vh] bg-black' />
                        <div className='w-[3px] h-[3px] bg-black' style={{transform:'rotate(45deg)'}}></div>
                    </div>
                    <InViewComponent reffing={cut3} active='cut_down_active'delay={2000}/>
                    <div className='relative top-0 left-0 w-full'>
                        <div id='lounge' className='absolute top-[-15vh]'></div>
                        <div className='flex flex-col w-full items-center justify-center'>
                            <div ref={ref3} className='title_text relative text-d-35 playfair-display my-[79px]'>{CONTENT.nearBy[lang]}</div>
                            <InViewComponent reffing={ref3} active='title_text_active'delay={2000}/>
                            <div ref={refBullet} className='title_text grid grid-cols-1 md:grid-cols-2 w-[60%] md:grid-[90%]'>
                                {Object.entries(NEARBY).map(([key, value], idx) => {
                                    return(
                                        <div key={idx} className='w-full flex flex-row items-center justify-center text-d-12 w-full py-[12px]'>
                                            <div className='flex flex-row items-center justify-start'>
                                                <div className='w-[5px] h-[5px] rounded-full bg-black'></div>
                                                <div className='w-[200px] text-d-16 font-[600] px-[12px]' style={{whiteSpace:'pre-wrap'}}>{value.title[lang]}</div>
                                            </div>
                                        </div>
                                    )
                                }
                                )}
                            </div>
                            <InViewComponent reffing={refBullet} active='title_text_active'delay={2000}/>
                        </div>
                    </div>
                </div>
                {/* sec5 */}
                <div id='other info' className='relative x-padding w-full min-h-[80vh] flex flex-col items-center'>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                    <div className='absolute w-full h-full bg-[#9B998F] opacity-[0.1]'></div>
                    <div className='relative w-full h-full flex flex-col items-center justify-evenly py-[10vh]'>
                        <div ref={ref6} className='title_text text-d-35 playfair-display '>{CONTENT.otherInfo[lang]}</div>
                        <InViewComponent reffing={ref6} active='title_text_active' delay={1000}/>
                        <div ref={ref7} className='title_text w-full flex flex-col items-center justify-center'>
                            <div className='mb-[24px] text-d-16 font-[600] border-b-[1px] border-b-[#0FBAB5] px-[12px]'>{CONTENT.inout[lang]}</div>
                            <div className='w-full flex flex-col items-center justify-center text-d-12' style={{gap:12}}>
                                <div className='text-center'>{CONTENT.inout_1[lang]}</div>
                                <div>{CONTENT.checkIn[lang]}  15:00</div>
                                <div>{CONTENT.checkOut[lang]}  12:00</div>
                            </div>
                            <InViewComponent reffing={ref7} active='title_text_active'delay={0}/>
                        </div>
                        {/* <div ref={ref8} className='title_text mt-[36px] w-full flex flex-col items-center justify-center'>
                            <div className='mb-[24px] text-d-16 font-[600] border-b-[1px] border-b-[#0FBAB5] px-[12px]'>{CONTENT.cc[lang]}</div>
                            <div className='t w-full flex flex-col items-center justify-center text-d-12' style={{gap:12}}>
                                <div className='text-center'>{CONTENT.cc_1[lang]}</div>
                                <div>{CONTENT.cc_2[lang]}</div>
                            </div>
                            <InViewComponent reffing={ref8} active='title_text_active'delay={0}/>
                        </div> */}
                    </div>
                </div>
            </div>
            <Footer />
            <Mask />
        </div>
    )
    return(
        <div className='bg-white w-full flex flex-col'>
            <div className='w-full flex flex-col'>
                {/* sec1 */}
                <div className='w-full h-[50vh] addnavpadding relative'>
                    <div className='absolute bottom-5 left-5 vert-text text-white text-[8px] font-[500] m-show-d-hidden'>No. 21 Whitfield Road Causeway Bay Hong Kong Island Hong Kong</div>
                    <img src='./images/facility/banner.jpg' className='w-full h-full' style={{objectFit:'cover'}}></img>
                </div>
                <div className='relative x-padding w-full min-h-[97vh] flex flex-col items-center justify-center'>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                    <InViewComponent reffing={ref1} active='title_text_active'delay={2000}/>
                    <div ref={ref1} className='title_text relative text-d-35 playfair-display my-[79px]'>ocean view</div>
                    <div ref={cut1} className='cut_down w-[1px] h-[70px] absolute top-0 left-50 bg-black'></div>
                    <InViewComponent reffing={cut1} active='cut_down_active'delay={2000}/>
                    <div className='w-full max-w-[1102px] relative flex flex-col items-end justify-center two-k-concept-max-w'>
                        <img className='w-full' src='./images/facility/sec1.png' style={{aspectRatio:(1102/579)}}></img>
                        {/* <img className='absolute left-0 bottom-0' src='./images/facility/1_right.jpg' style={{aspectRatio:(622/430)}}></img> */}
                        <div ref={ref2} className='title_text facility-sec1-text text-d-12 mt-[-6%] d-881' style={{}}>The Ocean View nestled along the coastline, offers stunning 
                            habour views and luxurious accommodations. Each room features 
                            floor-to-ceiling windows, perfect for relaxation. Whether for a 
                            romantic getaway or a family vacation, the Ocean View is the 
                            perfect choice for an idyllic escape.
                        </div>
                        <InViewComponent reffing={ref2} active='title_text_active'delay={0}/>
                    </div>
                    <div className='w-full relative my-[24px]'>
                        <div ref={ref2_5} className='d-1012-m-show max-w-[419px] text-d-12 title_text' style={{lineHeight:'30px'}}>
                            The Ocean View nestled along the coastline, offers stunning 
                            habour views and luxurious accommodations. Each room features 
                            floor-to-ceiling windows, perfect for relaxation. Whether for a 
                            romantic getaway or a family vacation, the Ocean View is the 
                            perfect choice for an idyllic escape.
                        </div>
                        <InViewComponent reffing={ref2_5} active='title_text_active'delay={0}/>
                    </div>
                </div>
                {/* sec2 */}
                {/* <div className='relative x-padding w-full min-h-[97vh] flex flex-col items-center justify-center'>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                    <div className='absolute w-full h-full bg-[#fff] opacity-[0.65]'></div>
                    <div ref={ref3} className='title_text relative text-d-35 playfair-display my-[79px]'>floor map</div>
                    <InViewComponent reffing={ref3} active='title_text_active'delay={0}/>
                    <div ref={cut2} className='cut_down w-[1px] h-[70px] absolute top-0 left-50 bg-black'></div>
                    <InViewComponent reffing={cut2} active='cut_down_active'delay={2000}/>
                    <div className='relative w-full max-w-[988px] pb-[10%] relative flex flex-col items-start justify-start'>
                        <img src='./images/facility/floor_3.png' className='w-full' style={{aspectRatio:988/332}}></img>
                        <img src='./images/facility/floor_2.png' className='w-full' style={{aspectRatio:988/332}}></img>
                        <img src='./images/facility/floor_1.png' className='w-full max-w-[810px]' style={{aspectRatio:810/332}}></img>
                    </div>
                </div> */}
                {/* sec3 */}
                <div className='w-full min-h-[97vh] flex flex-col items-center w-full relative py-[15vh]'>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full top-0 left-0' style={{objectFit:'cover'}}></img>
                    <div className='absolute w-full h-full bg-[#fff] opacity-[0.3] top-0 left-0'></div>
                    <div ref={cut3} className='cut_down flex flex-col items-center justify-center absolute top-0 left-[50%]'>
                        <div className='w-[1px] h-[10vh] bg-black' />
                        <div className='w-[3px] h-[3px] bg-black' style={{transform:'rotate(45deg)'}}></div>
                    </div>
                    <InViewComponent reffing={cut3} active='cut_down_active'delay={2000}/>

                    <div className='relative top-0 left-0 w-full h-full max-h-[900px]'>
                        <div id='lounge' className='absolute top-[-15vh]'></div>
                        {/* desktop */}
                        <div className='w-full h-full flex flex-row items-center justify-center d-924-m-hidden'>
                            <span className='cursor-pointer self-start mt-[6%] prev-arrow' onClick={() => setCaroIdx1(prev => prev - 1)}><LeftSvg /></span>
                            <div className='relative h-full min-h-[550px] w-[60%] facility-sec3-caro relative flex flex-row items-end justify-start'>
                                <div className='w-[40%] absolute top-0 left-[10%]' style={{aspectRatio:545/377}}>
                                    <Carousell imgArr={CARO1} idx={CaroIdx1} />
                                </div>
                                <div className='w-[49%] absolute bottom-[10%] right-[5%] caro1-up' style={{aspectRatio:545/377}}>
                                    <Carousell imgArr={CARO1} idx={CaroIdx1 + 1} />
                                </div>
                                <div ref={ref4} className='title_text max-w-[35%] text-d-12 ml-[10%] absolute bottom-0 left-0'>
                                    <div className='text-d-35 playfair-display'>lounge</div>
                                    <div className='text-d-12 facility-sec3-lineH'>
                                        The lounge is a serene retreat, designed for relaxation and 
                                        socializing. With plush seating and ambient lighting, it invites 
                                        guests to unwind with a book or enjoy a conversation over
                                        drinks. The stylish decor creates a warm atmosphere, while
                                        soft music enhances the experience. Whether you're catching 
                                        up with friends or taking a moment for yourself 
                                    </div>
                                    <InViewComponent reffing={ref4} active='title_text_active'delay={0}/>
                                </div>
                            </div>
                            <span className='cursor-pointer self-end mb-[10%]  next-arrow' onClick={() => setCaroIdx1(prev => (prev + 1))}><RightSvg /></span>
                        </div>
                        {/* mobile */}
                        <div className='w-full h-full flex flex-row items-center justify-center d-924-m-show'>
                            <div className='min-h-[550px] w-[60%] max-w-[1000px] relative flex flex-col items-start justify-start'>
                                <div className='flex w-full flex-row items-center justify-center'>
                                    <span className='cursor-pointer' onClick={() => setCaroIdx1(prev => prev - 1)}><LeftSvg /></span>
                                    <div className='w-full px-[12px]' style={{aspectRatio:545/377}}>
                                        <Carousell imgArr={CARO1} idx={CaroIdx1} />
                                    </div>
                                    <span className='cursor-pointer' onClick={() => setCaroIdx1(prev => (prev + 1))}><RightSvg /></span>
                                </div>
                                <div ref={ref4_2} className='title_text max-w-[100%] text-d-12 px-[12px]'>
                                    <div className='text-d-35 playfair-display'>lounge</div>
                                    <div className='text-d-12 ' style={{lineHeight:'30px'}}>
                                        The lounge is a serene retreat, designed for relaxation and 
                                        socializing. With plush seating and ambient lighting, it invites 
                                        guests to unwind with a book or enjoy a conversation over
                                        drinks. The stylish decor creates a warm atmosphere, while
                                        soft music enhances the experience. Whether you're catching 
                                        up with friends or taking a moment for yourself 
                                    </div>
                                    <InViewComponent reffing={ref4_2} active='title_text_active'delay={0}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* sec4 */}
                    <div className='relative top-0 left-0 w-full h-full max-h-[900px] mt-[10vh]'>
                        <div id='art and design' className='absolute top-[-15vh]'></div>
                        {/* desktop */}
                        <div className='w-full h-full flex flex-row items-center justify-center d-924-m-hidden'>
                            <span className='cursor-pointer self-start mt-[15%] prev-arrow' onClick={() => setCaroIdx2(prev => prev - 1)}><LeftSvg /></span>
                            <div className='relative h-full min-h-[550px] w-[60%] facility-sec3-caro relative flex flex-row items-end justify-end'>
                                <div className='w-[40%] absolute top-0 right-[10%]' style={{aspectRatio:545/377}}>
                                    <Carousell imgArr={CARO2} idx={CaroIdx2 + 1} />
                                </div>
                                <div className='w-[49%] absolute bottom-[10%] left-[5%] caro1-up' style={{aspectRatio:545/377}}>
                                    <Carousell imgArr={CARO2} idx={CaroIdx2} />
                                </div>
                                <div ref={ref5} className='title_text max-w-[35%] text-d-12 mr-[5%]'>
                                    <div className='text-d-35 playfair-display'>art and design</div>
                                    <div className='text-d-12 facility-sec3-lineH'>
                                        Art and designs by up-and-coming Japanese artists adorn 
                                        our hotel interior. We hope guests will enjoy the 
                                        mastery in these special pieces.
                                    </div>
                                    <InViewComponent reffing={ref5} active='title_text_active'delay={0}/>
                                </div>
                            </div>
                            <span className='cursor-pointer self-end mb-[20%]  next-arrow' onClick={() => setCaroIdx2(prev => (prev + 1))}><RightSvg /></span>
                        </div>
                        {/* mobile */}
                        <div className='w-full h-full flex flex-row items-center justify-center d-924-m-show'>
                            <div className='min-h-[550px] w-[60%] max-w-[1000px] relative flex flex-col items-start justify-start'>
                                <div className='flex w-full flex-row items-center justify-center'>
                                    <span className='cursor-pointer' onClick={() => setCaroIdx2(prev => prev - 1)}><LeftSvg /></span>
                                    <div className='w-full px-[12px]' style={{aspectRatio:545/377}}>
                                        <Carousell imgArr={CARO2} idx={CaroIdx2} />
                                    </div>
                                    <span className='cursor-pointer' onClick={() => setCaroIdx2(prev => (prev + 1))}><RightSvg /></span>
                                </div>
                                <div ref={ref5_2} className='title_text max-w-[100%] text-d-12 px-[12px]' style={{lineHeight:'30px'}}>
                                    <div className='text-d-35 playfair-display'>art and design</div>
                                    <div className=''>
                                        Art and designs by up-and-coming Japanese artists adorn 
                                        our hotel interior. We hope guests will enjoy the 
                                        mastery in these special pieces.
                                    </div>
                                    <InViewComponent reffing={ref5_2} active='title_text_active'delay={0}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* sec5 */}
                <div className='relative x-padding w-full min-h-[80vh] flex flex-col items-center'>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                    <div className='absolute w-full h-full bg-[#9B998F] opacity-[0.1]'></div>
                    <div className='relative w-full h-full flex flex-col items-center justify-evenly py-[10vh]'>
                        <div ref={ref6} className='title_text text-d-35 playfair-display '>other info</div>
                        <InViewComponent reffing={ref6} active='title_text_active' delay={1000}/>
                        <div ref={ref7} className='title_text w-full flex flex-col items-center justify-center'>
                            <div className='mb-[24px] text-d-16 font-[600] border-b-[1px] border-b-[#0FBAB5] px-[12px]'>check-in & check-out</div>
                            <div className='w-full flex flex-col items-center justify-center text-d-12' style={{gap:12}}>
                                <div className='text-center'>The check-in and check-out times for hakone kazan are as follows.</div>
                                <div>Check - in  15:00</div>
                                <div>Check - out  12:00</div>
                            </div>
                            <InViewComponent reffing={ref7} active='title_text_active'delay={0}/>
                        </div>
                        <div ref={ref8} className='title_text mt-[36px] w-full flex flex-col items-center justify-center'>
                            <div className='mb-[24px] text-d-16 font-[600] border-b-[1px] border-b-[#0FBAB5] px-[12px]'>credit card</div>
                            <div className='t w-full flex flex-col items-center justify-center text-d-12' style={{gap:12}}>
                                <div className='text-center'>We accept the following credit cards for payment of accommodation etc.</div>
                                <div>American Express, VISA, Mastercard, Diners Club, JCB card</div>
                            </div>
                            <InViewComponent reffing={ref8} active='title_text_active'delay={0}/>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <Mask />
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)